import { render, staticRenderFns } from "./WidgetViewPage.vue?vue&type=template&id=c32fee9a"
import script from "./WidgetViewPage.vue?vue&type=script&lang=js"
export * from "./WidgetViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports